import React from "react";
import PropTypes from "prop-types";

import { CustomModalButtons } from "../../constants/global.constants";
import { ExclamationIconRound, WarningIcon } from "../../packages/SVGs";
import WPButton from "../WPButton";
import WPHeading from "../WPHeading";
import { WPTypography } from "../WPTypography";
import StyledModal from "../../common/styles/components/modals/CustomModal";
import { combineClassNames } from "../../utils/appUtils";

import "./index.css";

export const DIALOG_TYPES = {
  ERROR: "danger",
  WARNING: "warning",
  SUCCESS: "success",
  INFO: "info",
};

const ICONS = {
  [DIALOG_TYPES.WARNING]: <WarningIcon />,
  [DIALOG_TYPES.ERROR]: <ExclamationIconRound />,
  [DIALOG_TYPES.SUCCESS]: <ExclamationIconRound />,
  [DIALOG_TYPES.INFO]: <ExclamationIconRound />,
};

const ConfirmationPopup = ({
  header,
  type,
  onClose,
  description,
  confirmBtn,
  cancelBtn,
  wrapContent,
  width,
  customClassName,
  open,
}) => {
  const buttonType = type === DIALOG_TYPES.WARNING ? "warning" : "danger";

  const handleClick = ({ target }) => onClose(target.id);

  if (!open) return null;

  return (
    <StyledModal
      show={open}
      centered
      onHide={() => onClose(CustomModalButtons.CANCEL)}
      backdrop="static"
      maxWidth={width || "416px"}
      isWarningPopUp
      className={combineClassNames("confirmation-popup", customClassName)}
    >
      <StyledModal.Body>
        <div className="message-pop-up">
          {type && <div className="icon-container">{ICONS[type]}</div>}
          <div className="message-margin">
            <WPHeading
              text={header}
              type="default"
              wrapContent={wrapContent}
              className="popup-header"
            />
            {description && (
              <WPTypography
                className="description-container fs-14"
                text={description}
                renderHtml
              />
            )}
          </div>
        </div>
      </StyledModal.Body>
      <StyledModal.Footer>
        {cancelBtn && (
          <WPButton
            id={CustomModalButtons.CANCEL}
            variant="outlined"
            type={buttonType}
            onClick={handleClick}
          >
            {cancelBtn}
          </WPButton>
        )}
        {confirmBtn && (
          <WPButton
            id={CustomModalButtons.CONFIRM}
            type={buttonType}
            onClick={handleClick}
          >
            {confirmBtn}
          </WPButton>
        )}
      </StyledModal.Footer>
    </StyledModal>
  );
};

ConfirmationPopup.propTypes = {
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  type: PropTypes.oneOf(Object.values(DIALOG_TYPES)),
  onClose: PropTypes.func.isRequired,
  description: PropTypes.string,
  confirmBtn: PropTypes.string,
  cancelBtn: PropTypes.string,
  wrapContent: PropTypes.bool,
  width: PropTypes.string,
  customClassName: PropTypes.string,
  open: PropTypes.bool,
};

ConfirmationPopup.defaultProps = {
  type: DIALOG_TYPES.ERROR,
  wrapContent: false,
  customClassName: "",
  open: false,
};

export default ConfirmationPopup;
